<script>
import DibbleJS from '@/dibble';
import DibbleApi from '@/api';
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';

export default {
    components: {
        TextField,
        SelectField,
    },
    name: 'RegisterStep2',
    data() {
        return {
            email: '',
            password: '',
            re_password: '',
            phone_num: '',
            country_code: '',
            country_codes: [],
            isShowPassword: false,
            isShowRePassword: false,
        };
    },
    methods: {
        onSubmit() {
            this.$emit('submit', {
                email: this.email,
                password: this.password,
                re_password: this.re_password,
                phone_num: this.phone_num,
                country_code: this.country_code,
            });
        },
        setData(value) {
            this.email = value.email;
            this.password = value.password;
            this.re_password = value.re_password;
            this.country_code = value.country_code;
            this.phone_num = value.phone_num;
        },
        getCountryCodes() {
            const params = {
                '#request': DibbleApi.api.getCountryCodes,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { countries } = response;
                    if (countries.length) {
                        this.country_codes = countries.map((item) => ({
                            value: item.country_code,
                            label: `+ ${item.dialing_code} (${item.name})`,
                            show_label: `+ ${item.dialing_code} (${item.country_code})`,
                        }));
                    }
                }
            });
        },
        toggleShowPassword() {
            this.isShowPassword = !this.isShowPassword;
        },
        toggleShowRePassword() {
            this.isShowRePassword = !this.isShowRePassword;
        },
    },
    mounted() {
        if (!this.country_codes.length) {
            this.getCountryCodes();
        }
    },
};
</script>

<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <TextField
                v-model="email"
                name="email"
                label="Email Address"
                rules="required|email"
            />
            <TextField
                v-model="password"
                name="password"
                label="Password"
                rules="required"
                :type="isShowPassword ? 'text' : 'password'"
            >
                <template #append-icon>
                    <a @click.prevent="toggleShowPassword">
                        <i
                            class="fa text-secondary"
                            :class="[
                                isShowPassword ? 'fa-eye-slash' : 'fa-eye',
                            ]"
                        />
                    </a>
                </template>
            </TextField>
            <TextField
                v-model="re_password"
                name="re_password"
                label="Repeat Password"
                rules="required|confirmed:password"
                :type="isShowRePassword ? 'text' : 'password'"
            >
                <template #append-icon>
                    <a @click.prevent="toggleShowRePassword">
                        <i
                            class="fa text-secondary"
                            :class="[
                                isShowRePassword ? 'fa-eye-slash' : 'fa-eye',
                            ]"
                        />
                    </a>
                </template>
            </TextField>
            <div class="row mb-4">
                <div class="col-7">
                    <SelectField
                        v-model="country_code"
                        name="country_code"
                        label="Country Code"
                        rules="required"
                        :options="country_codes"
                    />
                </div>
                <div class="col-5">
                    <TextField
                        v-model="phone_num"
                        name="phone_num"
                        label="Phone Number"
                        rules="required|numeric"
                    />
                </div>
            </div>
            <button
                class="btn-dialog btn-sm ok-btn w-100"
                type="submit"
                :disabled="invalid"
            >
                NEXT
                <i class="fa fa-chevron-right ml-2" aria-hidden="true"></i>
            </button>
        </form>
    </ValidationObserver>
</template>
